import React, { useState } from "react";

import { Editor, Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import Button from "ds/Button";
import Modal from "ds/Modal";

import * as S from "./styles";

type ModalIDEProps = {
  closeModal: () => void;
  onSave: (value: string) => void;
  value?: string;
  title?: string;
};

const ModalIDE = ({ closeModal, onSave, value, title }: ModalIDEProps) => {
  const [newValue, setNewValue] = useState(value ?? "");
  const intl = useIntl();

  const handleChange = (val: string) => {
    setNewValue(val);
  };

  const handleSave = () => {
    onSave(newValue);
    closeModal();
  };

  return (
    <Modal
      isOpen={true}
      size="large"
      onOpenChange={closeModal}
      handleClose={closeModal}
    >
      {title && <Typography.Title tag="h2">{title}</Typography.Title>}
      <S.Ide>
        <Editor value={newValue} onChange={handleChange} />
      </S.Ide>

      <S.Footer justifyContent="end">
        <Button type="submit" onClick={handleSave}>
          {intl.formatMessage({ id: "modal.ide.update" })}
        </Button>
        <Button variant="secondary" onClick={closeModal}>
          {intl.formatMessage({ id: "cancel" })}
        </Button>
      </S.Footer>
    </Modal>
  );
};

export default ModalIDE;
